interface Props {
    name: string;
    label: string;
    checked: boolean;
    value: string | boolean | number;
    radioGroup: string;
    onChange: (name: string, value: string | boolean | number) => void;
    hidden?: boolean | null;
    disabled?: boolean | null;
}

export default function CheckRadioButton({
    name,
    label,
    value,
    checked,
    onChange,
    hidden = false,
    radioGroup = name,
    disabled = false,
}: Props) {
    return (
        <div
            className='form-check checked-custom '
            key={name}
            hidden={hidden!}
            style={{
                marginTop: -8,
            }}
        >
            <input
                disabled={disabled ?? false}
                className='form-check-input'
                type='radio'
                checked={checked}
                value={value.toString()}
                name={radioGroup}
                id={name + '_' + value}
                radioGroup={radioGroup}
                onChange={(event) => {
                    onChange(name, value);
                }}
            />
            <label htmlFor={name + '_' + value} className='form-check-label'>
                {label}
            </label>
        </div>
    );
}
